export const id = (a) => a;

